// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".oneline[data-v-6ecd31b9]{grid-gap:10px;gap:10px;width:100%}.oneline[data-v-6ecd31b9],.style-edit[data-v-6ecd31b9]{display:flex;flex-wrap:wrap}.style-edit[data-v-6ecd31b9]{align-items:flex-end;grid-gap:20px;gap:20px}.style-edit__reset[data-v-6ecd31b9]{height:30px}.style-edit__btn[data-v-6ecd31b9]{min-width:80px}.style-edit__fields[data-v-6ecd31b9]{display:flex;align-items:flex-start;grid-gap:20px;gap:20px;flex-wrap:wrap}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
